import { createEnum } from "@redotech/zod/zod-enum";

export enum FlushReason {
  LIQUIDATE = "liquidate",
  DONATE = "donate",
}

export const FlushReasonSchema = createEnum(FlushReason, {
  enumName: "FlushReason",
});

export const FLUSH_BIN_NAMES: Record<FlushReason, string> = {
  [FlushReason.LIQUIDATE]: "FLUSH_LIQUIDATE",
  [FlushReason.DONATE]: "FLUSH_DONATE",
};
